// Auto-rotating reviews slider with crossfade. Pauses on hover; dots jump.
class HomeReviewsSlider extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.home-reviews__item'));
    this.dots = Array.from(this.querySelectorAll('.home-reviews__dot'));
    this.count = this.items.length;
    if (this.count <= 1) return;

    this.current = 0;
    this.delay = (Number(this.dataset.interval) || 5) * 1000;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.select(Number(dot.dataset.index));
        this.restart();
      });
    });

    this.addEventListener('pointerenter', () => this.stop());
    this.addEventListener('pointerleave', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  select(index) {
    this.current = index;
    this.items.forEach((el) => el.toggleAttribute('data-active', Number(el.dataset.index) === index));
    this.dots.forEach((el) => el.setAttribute('aria-current', Number(el.dataset.index) === index ? 'true' : 'false'));
  }

  next() {
    this.select((this.current + 1) % this.count);
  }

  start() {
    if (this.reduceMotion || this.timer) return;
    this.timer = setInterval(() => this.next(), this.delay);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('home-reviews-slider')) {
  customElements.define('home-reviews-slider', HomeReviewsSlider);
}
